import { Box, Grid } from '@mui/material';
import DateDisplay from '../display/date';
import { Product } from '../../services/interface/Shared';
import Price from '../display/price';
import PriceBreakdown from './price-breakdown';
import { flipToPositive } from '../../utils';

interface ISummaryPriceProps {
	totalAmountPayable?: number;
	mtaStartDate: string;
	fee?: number;
	product: Product;
}

const SummaryPrice = ({ totalAmountPayable, mtaStartDate, fee, product }: ISummaryPriceProps) => {
	return (
		<Box sx={{ mb: 4 }}>
			<Grid container spacing={3}>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Box
						sx={{
							border: '1px solid',
							borderColor: 'divider',
							p: 2,
							borderRadius: 2,
							height: '100%',
						}}
					>
						<DateDisplay date={mtaStartDate} description='Change Effective From' />
					</Box>
				</Grid>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Box
						sx={{
							border: '1px solid',
							borderColor: 'divider',
							p: 2,
							borderRadius: 2,
							height: '100%',
						}}
					>
						{totalAmountPayable && totalAmountPayable > 0 && (
							<Price color='primary.main' value={totalAmountPayable} description='Total Amount' />
						)}
						{totalAmountPayable && totalAmountPayable < 0 && (
							<Price color='primary.main' value={flipToPositive(totalAmountPayable)} description='Refund Amount' />
						)}
						<PriceBreakdown price={totalAmountPayable} fee={fee} product={product} />
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
};

export default SummaryPrice;
